<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="订单商品售后申请" :breadcrumbItem="[{to:'/orders/list',name:'订单列表'}]"></breadcrumb>

    <!-- begin page-header -->
    <h1 class="page-header">
      订单商品售后申请
      <small>订单商品售后申请...,微信付款[退款]到个人账号，必须金额是大于1元</small>
    </h1>
    <!-- end page-header -->
    <panel title="订单售后申请列表">
      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.goods_name" placeholder="商品名称"></Input>
        </Col>
        <Col span="4">
          <DatePicker
            v-model="orderdate"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="评价日期"
            style="width: 100%"
          ></DatePicker>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.status">
            <Option :value="99">不限制</Option>
            <Option :value="0">未审批</Option>
            <Option :value="1">审批通过</Option>
            <Option :value="-1">审批不通过</Option>
            <Option :value="2">处理完成</Option>
          </Select>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>
      <Table class="m-t-10" :columns="columns" :data="datas">
        <template slot="order_sn" slot-scope="{row}">{{row.order.order_sn}}</template>
        <template slot="ordergoods" slot-scope="{row}">
          <p
            v-for="(item,index) in row.order.ordergoods"
            :key="index"
          >{{item.goods_name}} {{item.goods_number}} * ￥{{item.promotion_price}}</p>
        </template>
        <template slot="comments" slot-scope="{row}">
          <Card :bordered="false">
            <p>{{row.user_name}} {{row.created_at}}</p>
            <p v-if="row.mobile.length >0">手机号码: {{row.mobile}}</p>
            <p>内容: {{row.content}}</p>
            <div class="row">
              <div class="col-md-4" v-for="(item,k) in row.images" :key="k">
                <img
                  :src="logourl + item"
                  style="max-width:100%;max-height:100%;width:auto;height:auto"
                />
              </div>
            </div>
          </Card>
        </template>
        <template slot="status" slot-scope="{row}">
          {{row.order.paymethodname}}
          <br />
          <span v-if="row.status ==0">未审批</span>
          <span v-else-if="row.status == 1" style="color:green">审批通过</span>
          <span v-else-if="row.status == 2" style="color:green">处理完成</span>
          <span v-else-if="row.status == -1" style="color:red">审批不通过</span>
          <span v-if="row.refundflag == 1" style="color:red">
            <br />已退款
          </span>
        </template>
        <template slot="action" slot-scope="{row}">
          <Poptip
            v-if="row.status == 1 && row.refundflag == 0"
            transfer
            confirm
            title="要处理这个售后的退款?"
            @on-ok="fn_refund(row.id)"
            ok-text="确定"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger m-r-10">退款</button>
          </Poptip>

          <Poptip
            transfer
            confirm
            title="审批售后申请单?"
            @on-ok="fn_approve(row,1)"
            @on-cancel="fn_approve(row,-1)"
            ok-text="审批通过"
            cancel-text="不通过"
          >
            <button type="button" class="btn btn-theme m-r-10">审批</button>
          </Poptip>
          <button type="button" class="btn btn-theme m-r-10" @click="fn_proc_service(row)">处理方式</button>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="filterCond.page"
        :page-size="filterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer :closable="true" title="处理方式" width="60" v-model="v_edit">
      <Form>
        <FormItem>
          <Input type="textarea" :rows="10" v-model="formData.procontent"></Input>
        </FormItem>
        <FormItem>
          <Checkbox v-model="profinish">处理完成</Checkbox>
        </FormItem>
        <FormItem label>
          <button type="button" class="btn btn-theme" @click="fn_save_procontent()">保存</button>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import {
  getOrderSalerServiceList,
  approveOrderSalerService,
  saveProOrderSalerService,
  refundSalerOrderService
} from "@/api/order";

import config from "@/config";
import moment from "moment";
export default {
  components: { breadcrumb },
  data() {
    return {
      logourl: config.baseUrl.imageurl,
      orderdate: [],
      filterCond: {
        begindate: "",
        enddate: "",
        goods_name: "",
        status: 0,
        page: 1,
        pageNum: 10
      },
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "订单号",
          slot: "order_sn",
          width: 180
        },
        {
          title: "订单商品",
          slot: "ordergoods"
        },
        {
          title: "内容",
          slot: "comments"
        },
        {
          title: "处理内容",
          key: "procontent"
        },
        {
          title: "状态",
          slot: "status",
          width: 100
        },
        {
          title: "操作",
          slot: "action",
          width: 250
        }
      ],
      datas: [],
      totalRows: 0,
      v_edit: false,
      formData: {},
      profinish: false
    };
  },
  mounted() {
    this.fn_load(this.filterCond);
  },
  methods: {
    fn_refund(id) {
      refundSalerOrderService(id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({
              title: "成功",
              desc: res.data.desc
            });
          } else {
            this.$Notice.error({
              title: "失败",
              desc: res.data.desc
            });
          }
        })
        .catch(error => {
          this.$Message.error("错误:" + error);
        });
    },
    fn_save_procontent() {
      if (this.profinish) {
        this.formData.status = 2;
      }
      saveProOrderSalerService(this.formData)
        .then(res => {
          this.v_edit = false;
          this.$Notice.success(res.data);
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_proc_service(row) {
      this.v_edit = true;
      this.formData = row;
      if (this.formData.status == 2) this.profinish = true;
      else this.profinish = false;
    },

    fn_query() {
      this.filterCond.page = 1;
      this.fn_load(this.filterCond);
    },
    fn_load(filterCond) {
      if (this.orderdate.length > 0) {
        this.filterCond.begindate = moment(this.orderdate[0]).format(
          "YYYY-MM-DD"
        );
        this.filterCond.enddate = moment(this.orderdate[1]).format(
          "YYYY-MM-DD"
        );
      } else {
        this.filterCond.begindate = "";
        this.filterCond.enddate = "";
      }
      getOrderSalerServiceList(filterCond)
        .then(res => {
          this.datas = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_load(this.filterCond);
    },
    fn_approve(row, status) {
      let data = {
        id: row.id,
        status: status
      };
      approveOrderSalerService(data)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            row.status = status;
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>